(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vipa-proof-compact"] && !Shopify.designMode) return;
  try {
    (function(){
  'use strict';
  const version='20261007-badge-palette-bg81.1';
  if(window.vipaCompactProof&&window.vipaCompactProof.version===version)return;
  function refresh(){
    const main=document.querySelector('main');
    if(!main)return;
    const params=new URLSearchParams(location.search);
    // This script exists only in the comparison theme; Shopify can retain a preview via its cookie.
    main.dataset.vipaBadgePalette=params.get('vipa_badge')==='green'?'green':'black';
    main.dataset.vipaBadgeBuild='bg81';
    main.querySelectorAll('.vipa-sales-context').forEach(node=>node.remove());
  }
  window.vipaCompactProof={version,refresh};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
  document.addEventListener('shopify:section:load',refresh);
  window.addEventListener('pageshow',refresh);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vipa-review-loader"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.vipaReviewLoaderV4) return;
  const libraries = new Map(), states = new WeakMap();
  const urls = {carousel:'https://widget.reviews.io/carousel-inline-iframeless/dist.js',product:'https://widget.reviews.io/polaris/build.js',rating:'https://widget.reviews.io/modern-widgets/rating-bar.js'};
  const sleep = ms => new Promise(resolve => setTimeout(resolve,ms));
  let ratingReloads = 0;
  function constructorFor(kind) {
    if (kind === 'carousel') {
      if (typeof window.carouselInlineWidget === 'function') return window.carouselInlineWidget;
      if (typeof carouselInlineWidget === 'function') return carouselInlineWidget;
    }
    if (kind === 'product') {
      if (typeof window.ReviewsWidget === 'function') return window.ReviewsWidget;
      if (typeof ReviewsWidget === 'function') return ReviewsWidget;
    }
    return null;
  }
  function matchingScript(url) {
    return Array.from(document.scripts).find(script => {
      try {const actual=new URL(script.src,location.href), wanted=new URL(url);return actual.origin===wanted.origin && actual.pathname===wanted.pathname && script.dataset.vipaLoadFailed!=='1';}catch(_){return false;}
    });
  }
  function stylesheet(url) {
    if (Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(link=>link.href.split('?')[0]===url)) return;
    const link=document.createElement('link');link.rel='stylesheet';link.href=url;document.head.appendChild(link);
  }
  function library(url,ready) {
    if(ready && ready())return Promise.resolve();
    if(libraries.has(url))return libraries.get(url);
    const promise=new Promise((resolve,reject)=>{
      let script=matchingScript(url);const created=!script;
      if(script && script.type && !['text/javascript','application/javascript','module'].includes(script.type)){reject(new Error('Review script is blocked by consent settings'));return;}
      if(created){script=document.createElement('script');script.src=url;script.async=true;script.dataset.vipaOwned='1';}
      let settled=false,timer,interval;
      function finish(error){if(settled)return;settled=true;clearTimeout(timer);clearInterval(interval);script.removeEventListener('load',loaded);script.removeEventListener('error',failed);if(error){if(script.dataset.vipaOwned==='1')script.dataset.vipaLoadFailed='1';reject(error);}else resolve();}
      function loaded(){script.dataset.vipaLoaded='1';if(!ready||ready())finish();}
      function failed(){finish(new Error('Review provider script could not be loaded'));}
      script.addEventListener('load',loaded);script.addEventListener('error',failed);
      interval=setInterval(()=>{if(ready&&ready())finish();},100);timer=setTimeout(failed,12000);
      if(created)document.head.appendChild(script);else if(script.dataset.vipaLoaded==='1'||(ready&&ready()))loaded();
    });
    libraries.set(url,promise);promise.catch(()=>libraries.delete(url));return promise;
  }
  function hasContent(target) {
    const copy=target.cloneNode(true);copy.querySelectorAll('script,style').forEach(node=>node.remove());
    const text=copy.textContent.replace(/\s+/g,' ').trim();
    return Boolean(target.querySelector('iframe') || (text.length>24 && !/^loading\b/i.test(text)) || (target.shadowRoot && target.shadowRoot.textContent.trim().length>24));
  }
  function feedback(root,key) {
    const status=root.querySelector('[data-vipa-review-status]'),retry=root.querySelector('[data-vipa-review-retry]');
    root.setAttribute('aria-busy',key==='loading'?'true':'false');root.dataset.vipaReviewState=key;
    if(status){status.textContent=root.dataset[key]||'';status.hidden=key==='ready';}
    if(retry)retry.hidden=key!=='failed';
  }
  async function waitForContent(target) {
    for(let attempt=0;attempt<90;attempt++){if(!target.isConnected)return false;if(hasContent(target))return true;await sleep(200);}return false;
  }
  async function mount(root) {
    const kind=root.dataset.vipaReviewKind,target=root.querySelector('[data-vipa-review-target]');
    if(!urls[kind]||!target)return;
    let state=states.get(root);if(!state){state={busy:false,ready:false,instance:null};states.set(root,state);}
    if(state.busy||state.ready)return;
    if(hasContent(target)){state.ready=true;feedback(root,'ready');return;}
    state.busy=true;feedback(root,'loading');delete root.dataset.vipaReviewError;
    try {
      if(kind==='rating') {
        const existing=matchingScript(urls.rating);
        if(existing){
          await sleep(800);
          const blocked=existing.type&&!['text/javascript','application/javascript','module'].includes(existing.type);
          if(!hasContent(target)&&!blocked&&ratingReloads<1){ratingReloads++;const script=document.createElement('script');script.src=urls.rating+'?vipa_refresh=1';script.async=true;document.head.appendChild(script);}
        }else await library(urls.rating,null);
      }else if(!state.instance) {
        await library(urls[kind],()=>Boolean(constructorFor(kind)));
        if(!root.isConnected)return;
        const Constructor=constructorFor(kind);
        if(!Constructor)throw new Error('Provider constructor unavailable');
        if(kind==='carousel') {
          stylesheet('https://assets.reviews.io/css/widgets/carousel-widget.css');
          stylesheet('https://assets.reviews.io/iconfont/reviewsio-icons/style.css');
          const original=root.dataset.vipaCarouselStyle==='original';
          state.instance=new Constructor(target.id,{
            store:'www.vipacarparts.com',sku:'',lang:root.dataset.language||'en',carousel_type:'default',styles_carousel:original?'CarouselWidget--sideHeader':'CarouselWidget--sideHeader--withcards',
            options:{
              general:{review_type:'company, product',min_reviews:'1',max_reviews:'20',enable_auto_scroll:window.matchMedia('(prefers-reduced-motion: reduce)').matches?false:(original?10000:7000),enable_pause_button:true},
              header:{enable_overall_stars:true,rating_decimal_places:original?2:1},
              reviews:{enable_customer_name:true,enable_customer_location:original,enable_verified_badge:true,enable_photos:true,enable_videos:true,enable_review_date:true,disable_same_customer:true,hide_empty_reviews:true,enable_product_name:true,min_review_percent:4},
              popups:{enable_review_popups:true,enable_helpful_buttons:true,enable_helpful_count:true}
            },
            styles:original?{'--base-font-size':'16px','--base-maxwidth':'100%','--reviewsio-logo-style':'var(--logo-normal)','--common-star-color':'#FFCC00','--common-star-disabled-color':'rgba(0,0,0,0.25)','--medium-star-size':'22px','--small-star-size':'19px','--x-small-star-size':'16px','--header-width':'160px','--header-padding':'0.5em','--header-bg-start-color':'transparent','--header-bg-end-color':'transparent','--header-border-width':'0px','--header-shadow-size':'0px','--item-maximum-columns':'5','--item-background-start-color':'transparent','--item-background-end-color':'transparent','--item-padding':'0.5em','--item-border-width':'0px','--item-border-radius':'0px','--item-shadow-size':'0px','--heading-text-color':'#0E1311','--heading-text-font-weight':'600','--body-text-color':'#0E1311','--body-text-font-weight':'400','--body-text-line-height':'1.4','--scroll-button-icon-color':'#0E1311','--scroll-button-bg-color':'transparent','--scroll-button-border-width':'0px','--badge-icon-color':'#007f4e'}:{'--base-font-size':'15px','--base-maxwidth':'100%','--header-width':'200px','--header-padding':'1em','--item-maximum-columns':'3','--item-minimum-width':'230px','--common-star-color':'#b79a55','--item-padding':'1em','--item-border-radius':'10px','--item-background-start-color':'#ffffff','--item-background-end-color':'#ffffff','--item-border-width':'1px','--item-border-color':'#e5e5e5'}
          });
          root.dataset.vipaCarouselLayout=original?'original-provider-carousel':'three-column-cards';
        }else {
          const sku=Array.from(new Set((root.dataset.skus||'').split(';').map(value=>value.trim()).filter(Boolean))).join(';');
          if(!sku)throw new Error('No product SKU available');
          state.instance=new Constructor('#'+target.id,{
            store:'www.vipacarparts.com',widget:'polaris',
            options:{
              types:'product_review,questions',enable_sentiment_analysis:true,lang:root.dataset.language||'en',layout:'',per_page:15,
              product_review:{sku:sku,hide_if_no_results:false},
              questions:{hide_if_no_results:false,enable_ask_question:true,enable_ask_question_button_style:false,show_dates:true,grouping:root.dataset.questionSku||sku.split(';')[0]},
              header:{enable_summary:true,enable_ratings:true,enable_attributes:true,enable_image_gallery:true,enable_percent_recommended:false,enable_write_review:true,enable_ask_question:true,enable_sub_header:true,rating_decimal_places:2,use_write_review_button:false,enable_if_no_results:false},
              filtering:{enable:true,enable_text_search:true,enable_sorting:true,enable_product_filter:false,enable_media_filter:true,enable_overall_rating_filter:true,enable_language_filter:false,enable_ratings_filters:true,enable_attributes_filters:true,enable_expanded_filters:false},
              reviews:{enable_avatar:true,enable_reviewer_name:true,enable_reviewer_address:false,enable_verified_badge:true,enable_subscriber_badge:true,enable_reviewer_recommends:true,enable_attributes:true,enable_product_name:true,enable_replies:true,enable_images:true,enable_ratings:true,enable_share:true,enable_helpful_vote:true,enable_helpful_display:true,enable_report:true,enable_date:true,enable_third_party_source:true}
            },
            styles:{'--base-font-size':'16px','--common-star-color':'#B79A55','--heading-text-color':'#333333','--body-text-color':'#555555','--body-text-font-weight':'400','--body-text-line-height':'1.5','--common-button-border-radius':'6px','--primary-button-bg-color':'#0E1311','--primary-button-text-color':'#ffffff'}
          });
        }
      }
      state.ready=await waitForContent(target);
      if(root.isConnected){feedback(root,state.ready?'ready':'failed');if(!state.ready)root.dataset.vipaReviewError='Provider did not return review content';}
    }catch(error){if(root.isConnected){root.dataset.vipaReviewError=error.message||'Review loading failed';feedback(root,'failed');}}
    finally{state.busy=false;}
  }
  function scan(){document.querySelectorAll('[data-vipa-review-kind]').forEach(root=>mount(root));}
  const api={scan:scan,version:'4.3-combined-reviews-20261007'};window.vipaReviewLoaderV4=api;window.vipaReviewLoaderV3=api;
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-vipa-review-retry]');if(!button)return;
    const root=button.closest('[data-vipa-review-kind]'),state=root&&states.get(root);if(!state||state.busy)return;
    const target=root.querySelector('[data-vipa-review-target]');
    if(hasContent(target)){state.ready=true;feedback(root,'ready');return;}
    if(state.instance&&typeof state.instance.destroy==='function')state.instance.destroy();
    target.replaceChildren();state.instance=null;state.ready=false;
    if(root.dataset.vipaReviewKind==='rating')ratingReloads=0;
    mount(root);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);window.addEventListener('pageshow',scan);
})();
  } catch(e) { console.error(e); }
})();

})();
